import { render, staticRenderFns } from "./ConfirmCheckout.vue?vue&type=template&id=5c2c379b&scoped=true"
import script from "./ConfirmCheckout.vue?vue&type=script&lang=js"
export * from "./ConfirmCheckout.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCheckout.vue?vue&type=style&index=0&id=5c2c379b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2c379b",
  null
  
)

export default component.exports